import evaluateUIRules from "./RuleEvaluate";
import { ErrorObject } from "ajv";

const extractScopes: any = (schema: any, ctx: any) => {
  let scopes: any = [];

  if (Array.isArray(schema)) {
    schema?.forEach((item) => {
      scopes = scopes.concat(extractScopes(item, ctx));
    });
  } else if (typeof schema === "object" && schema !== null) {
    if (schema?.additionalData?.customRule) {
      let value = evaluateUIRules(schema?.additionalData, ctx);
      if (!value) return;
    }
    if (schema.scope) {
      const scopeValue = schema.scope.split("properties/")[1];
      if (scopeValue) {
        scopes.push({
          propertyKey: scopeValue,
          validationRules: schema.validationRules,
          dataValue: ctx?.core?.data[scopeValue],
        });
      }
    }

    if (schema.elements) {
      scopes = scopes.concat(extractScopes(schema.elements, ctx));
    }
  }

  return scopes;
};
const filterAndRemoveDuplicateByKey = (arr: any[], propertyKey: string) => {
  const seen = new Set();
  return arr.filter((item) => {
    if (item && item[propertyKey] && !seen.has(item[propertyKey])) {
      seen.add(item[propertyKey]);
      return true;
    }
    return false;
  });
};

const parseDateTime = (obj: any) => {
  const { date, time } = obj;
  return new Date(`${date} ${time}`);
};

const rulesValidator = (data: any, core: any, dispatch: any) => {
  const { propertyKey, validationRules, dataValue } = data;

  const regexEvaluator = (pattern: string, data: string) => {
    const regex = new RegExp(pattern);

    if (!regex.test(data)) {
      const newError: ErrorObject = {
        instancePath: "/" + propertyKey,
        message: validationRules?.errorMessage?.pattern
          ? validationRules?.errorMessage?.pattern
          : `Please enter data in proper format`,
        schemaPath: "",
        keyword: "",
        params: {},
      };
      return newError;
    }

    return null;
  };

  //   Required Property
  if (validationRules?.required) {
    if (
      !dataValue ||
      (Array.isArray(dataValue) && dataValue.length === 0) ||
      (typeof dataValue === "object" && Object.keys(dataValue).length === 0)
    ) {
      const newError: ErrorObject = {
        instancePath: "/" + propertyKey,
        message: validationRules?.errorMessage?.required
          ? validationRules?.errorMessage?.required
          : "Field cannot be empty",
        schemaPath: "",
        keyword: "",
        params: {},
      };

      return newError;
    }
  }

  // Co-ordinates Rule
  if (validationRules?.coOrdinatesRequired) {
    if (
      (core?.data?.locationLink === undefined ||
        core?.data?.locationLink === "") &&
      !dataValue
    ) {
      const newError: ErrorObject = {
        instancePath: "/" + propertyKey,
        message: validationRules?.errorMessage?.required
          ? validationRules?.errorMessage?.required
          : "Field cannot be empty",
        schemaPath: "",
        keyword: "",
        params: {},
      };

      return newError;
    }
  }

  // Location Link rule
  if (validationRules?.locationLinkRequired) {
    if (
      (core?.data?.latitude === undefined || core?.data?.latitude === "") &&
      (core?.data?.longitude === undefined || core?.data?.longitude === "")
    ) {
      if (!dataValue) {
        const newError: ErrorObject = {
          instancePath: "/" + propertyKey,
          message: validationRules?.errorMessage?.required
            ? validationRules?.errorMessage?.required
            : "Field cannot be empty",
          schemaPath: "",
          keyword: "",
          params: {},
        };

        return newError;
      }

      const regex =
        "^(https?:\\/\\/)?(www\\.)?(google\\.com\\/maps\\/(place|search|dir|d)|maps\\.app\\.goo\\.gl)\\/.*$|^$";
      return regexEvaluator(regex, dataValue);
    }
  }

  // Required Property for Date and Time picker
  if (validationRules?.dateTimeRequired) {
    if (
      !dataValue ||
      (typeof dataValue === "object" && Object.keys(dataValue).length < 2)
    ) {
      const newError: ErrorObject = {
        instancePath: "/" + propertyKey,
        message: validationRules?.errorMessage?.required
          ? validationRules?.errorMessage?.required
          : "Field cannot be empty",
        schemaPath: "",
        keyword: "",
        params: {},
      };

      return newError;
    }

    if (dataValue?.date === undefined || dataValue?.time === undefined) {
      const newError: ErrorObject = {
        instancePath: "/" + propertyKey,
        message: validationRules?.errorMessage?.required
          ? validationRules?.errorMessage?.required
          : "Please enter both date and time",
        schemaPath: "",
        keyword: "",
        params: {},
      };

      return newError;
    }
  }

  // Required Property for Auction End Date
  if (validationRules?.auctionEndDate) {
    if (
      !dataValue ||
      (typeof dataValue === "object" && Object.keys(dataValue).length < 2)
    ) {
      const newError: ErrorObject = {
        instancePath: "/" + propertyKey,
        message: validationRules?.errorMessage?.required
          ? validationRules?.errorMessage?.required
          : "Field cannot be empty",
        schemaPath: "",
        keyword: "",
        params: {},
      };

      return newError;
    }

    if (dataValue?.date === undefined || dataValue?.time === undefined) {
      const newError: ErrorObject = {
        instancePath: "/" + propertyKey,
        message: validationRules?.errorMessage?.required
          ? validationRules?.errorMessage?.required
          : "Please enter both date and time",
        schemaPath: "",
        keyword: "",
        params: {},
      };
      return newError;
    }

    if (
      core?.data?.dateOfAuction?.date === undefined ||
      core?.data?.dateOfAuction?.time === undefined
    ) {
      const newError: ErrorObject = {
        instancePath: "/" + propertyKey,
        message: validationRules?.errorMessage?.required
          ? validationRules?.errorMessage?.required
          : "Please add auction start date and time ",
        schemaPath: "",
        keyword: "",
        params: {},
      };
      return newError;
    }

    const dateTime1 = parseDateTime(core?.data?.dateOfAuction);
    const dateTime2 = parseDateTime(dataValue);

    if (dateTime1 >= dateTime2) {
      const newError: ErrorObject = {
        instancePath: "/" + propertyKey,
        message: validationRules?.errorMessage?.required
          ? validationRules?.errorMessage?.required
          : "Auction end time should be after start time",
        schemaPath: "",
        keyword: "",
        params: {},
      };
      return newError;
    }
  }

  //   Minlength Rule
  if (validationRules?.minLength && dataValue) {
    const { minLength } = validationRules;

    if (typeof dataValue === "number") {
      const digitCount = Math.abs(dataValue).toString().replace(".", "").length;

      if (digitCount < minLength) {
        const newError: ErrorObject = {
          instancePath: "/" + propertyKey,
          message: validationRules?.errorMessage?.minLength
            ? validationRules?.errorMessage?.minLength
            : `Value cannot be less than ${minLength} characters`,
          schemaPath: "",
          keyword: "",
          params: {},
        };

        return newError;
      }
    } else {
      if (dataValue?.length < minLength) {
        const newError: ErrorObject = {
          instancePath: "/" + propertyKey,
          message: validationRules?.errorMessage?.minLength
            ? validationRules?.errorMessage?.minLength
            : `Value cannot be less than ${minLength} characters`,
          schemaPath: "",
          keyword: "",
          params: {},
        };

        return newError;
      }
    }
  }

  //   Maxlength Rule
  if (validationRules?.maxLength && dataValue) {
    const { maxLength } = validationRules;

    if (typeof dataValue === "number") {
      const digitCount = Math.abs(dataValue).toString().replace(".", "").length;
      if (digitCount > maxLength) {
        const newError: ErrorObject = {
          instancePath: "/" + propertyKey,
          message: validationRules?.errorMessage?.maxLength
            ? validationRules?.errorMessage?.maxLength
            : `Value cannot exceed ${maxLength} characters`,
          schemaPath: "",
          keyword: "",
          params: {},
        };

        return newError;
      }
    } else {
      if (dataValue?.length > maxLength) {
        const newError: ErrorObject = {
          instancePath: "/" + propertyKey,
          message: validationRules?.errorMessage?.maxLength
            ? validationRules?.errorMessage?.maxLength
            : `Value cannot exceed ${maxLength} characters`,
          schemaPath: "",
          keyword: "",
          params: {},
        };

        return newError;
      }
    }
  }

  if (validationRules?.posValue && dataValue) {
    if (isNaN(Number(dataValue))) {
      const newError: ErrorObject = {
        instancePath: "/" + propertyKey,
        message: `Please enter valid number`,
        schemaPath: "",
        keyword: "",
        params: {},
      };

      return newError;
    }

    if (Number(dataValue) < 0) {
      const newError: ErrorObject = {
        instancePath: "/" + propertyKey,
        message: validationRules?.errorMessage?.posValue
          ? validationRules?.errorMessage?.posValue
          : `Please enter positive value`,
        schemaPath: "",
        keyword: "",
        params: {},
      };
      return newError;
    }
  }

  //   Regex Pattern
  if (validationRules?.pattern && dataValue) {
    return regexEvaluator(validationRules?.pattern, dataValue);
  }
};

const validateData = (data: any, core: any, dispatch: any) => {
  let updatedErrors: ErrorObject[] = [];
  data?.forEach((item: any) => {
    let current_error = rulesValidator(item, core, dispatch);
    if (current_error) updatedErrors.push(current_error);
  });

  if (updatedErrors.length > 0) {
    dispatch({
      type: "jsonforms/UPDATE_ERRORS",
      errors: updatedErrors,
    });
    return false;
  }
  return true;
};

const customValidator = (uischema: any, ctx: any, step: any) => {
  const ui = uischema;
  const rawData = extractScopes(ui, ctx);
  const filteredData = filterAndRemoveDuplicateByKey(rawData, "propertyKey");

  return validateData(filteredData, ctx?.core, ctx?.dispatch);
};

export default customValidator;
